import React, { Component } from 'react';
import './App.css';
import { Provider } from 'unstated';
import Bracket from './Bracket';
import Detail from './Detail';
import Toolbar from './Toolbar';
import Header from './Header';
import Footer from './Footer';

class App extends Component {
    render() {
        return (
            <Provider>
                <div className="App">
                    <header>
                       <Header></Header> 
                    </header>
                    <content>
                        <Bracket />
                        <Detail />
                        <Toolbar />
                    </content>
                    <footer className="footer">
                        <Footer />
                    </footer>
                </div>
            </Provider>
        );
    }
}

export default App;